import { Button } from '@/components/ui/Button'

/**
 * Calm zero-enrollment state, shared by every page that needs a language: one sentence,
 * one action. The action opens the
 * language menu in the nav (its Discover group) rather than duplicating the list.
 */
export function NoLanguagesEmptyState() {
  function openLanguageMenu() {
    const trigger = document.querySelector<HTMLElement>('[aria-label="Select language"]')
    trigger?.focus()
    trigger?.click()
  }

  return (
    <div className="py-16 text-center">
      <p className="font-serif text-lg text-body leading-relaxed">
        You&rsquo;re not learning any languages yet &mdash; pick one from the language menu to begin.
      </p>
      <Button onClick={openLanguageMenu} className="mt-8 min-h-11">
        Choose a language
      </Button>
    </div>
  )
}
